export const SET_TRANSACTION_LOADING_STATUS =
  '@transactions/SET_TRANSACTION_LOADING_STATUS' as const;
export const SET_CURRENCY_INFO = '@transactions/SET_CURRENCY_INFO' as const;
export const SET_CURRENCY_TRANSFERS = '@transactions/SET_CURRENCY_TRANSFERS' as const;

export const GET_TRANSACTIONS_LIST = '@transactions/GET_TRANSACTIONS_LIST' as const;
export const GET_TRANSACTION = '@transactions/GET_TRANSACTION' as const;
export const SET_PAGE_NUMBER = '@transactions/SET_PAGE' as const;
export const GET_CURRENCY = '@transactions/GET_CURRENCY' as const;
export const GET_CURRENCY_TRANSFERS = '@transactions/GET_CURRENCY_TRANSFERS' as const;
export const GET_CURRENCY_INFO = '@transactions/GET_CURRENCY_INFO' as const;
export const CLEAR_CURRENCY_TRANSFERS = '@transactions/CLEAR_CURRENCY_TRANSFERS' as const;
